export default __webpack_public_path__ + "static/TarotIcon-3e62a765d4c2f646b17e547d6b50571a.png";